module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p39"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "CN"
  }, [_vm._v("9")]), _vm._v(" "), _c('h1', {
    staticClass: "chaptertitle "
  }, [_vm._v("Expelled from the Party")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("At the beginning of February we returned to Kazan, and I at once received a summons to the district committee. Why Yaroslavsky had decided to refer my case back to Kazan, I don’t know. Perhaps, after the insolent things I had said to him, he preferred not to set eyes on me again. But more probably there had been a general decision to have cases of expulsion dealt with on a lower level. There were more and more of them every day, and the control commission had more work than it could cope with.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("My summons was for February 7th. The secretary of the committee, Biktashev, had been a student of mine at the Tartar Communist University. His face was a picture of agony as he listened to the charges. I only vaguely remember what they were on this occasion, or how they differed from the last Moscow version. I was hardly listening. Both the members of the board and I knew that my expulsion was a foregone conclusion, and we both wanted to get the wretched business over as quickly as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Any questions?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Any comments?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Perhaps there’s something you’d like to say?” Biktashev asked me in a hoarse voice, without raising his eyes from the file in front of him. I could see he was afraid that I would. As if it weren’t obvious that he himself was suffering and could do nothing.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p40"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("But everything was clear to me. I no longer wished to talk about anything. Quietly going to the door, I said in a whisper:")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Settle it without me. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("We all knew that this was a break of Party regulations—no decision concerning a member could be taken in his or her absence—but what were regulations now? All Biktashev remembered was to say at the last moment:")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Your Party card . . . You have it with you?” Clearing his throat, he added:")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Leave it here. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("There was a pause, and now Biktashev and I looked each other in the eye. The same memories must have come to both of us—of that time ten years ago when I, a young lecturer, new to my job, was tutoring him, a half-literate boy newly arrived from his village. That the boy had risen to be secretary to the district committee was in part my work. To think of all the difficulties and little triumphs we had gone through together, and how many times I had corrected his homework! And how cheerful and eager his narrow Mongol eyes had been, and how abashed and sad they were now. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("All this went through my mind and, I felt sure, through his as well. His voice trembled as he said again:")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Leave the card here . . . for the time being. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“For the time being” was a poor effort to comfort me, to give me hope, as though he was trying to say that I would get it back someday, and that these things couldn’t go on for ever.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("I felt sorry for my old pupil Biktashev, a good, hard-working boy. It was worse for him than for me. Some actors in the horror play had been cast as victims, others "), _c('a', {
    attrs: {
      "id": "p41"
    }
  }), _vm._v("as persecutors, and these were the worse off. At least my conscience was clear.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Yes, I have my card.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("It still looked quite new: there had been a new issue throughout the country as recently as 1935. What care I had taken of it, how afraid I had been of losing it! I put it down on the desk.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("My husband was waiting in the street outside. We set off on foot. It would not have done to go by streetcar, looking as upset as we did. We said nothing until halfway home, then he asked:")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Well, what happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I had to leave my card. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("He sighed softly. It was clear to him now how close we were to the precipice.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5f1f8ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c09.vue
// module id = 96
// module chunks = 0